import { render, staticRenderFns } from "./ObservationReportingForm.vue?vue&type=template&id=0cafd464&scoped=true"
import script from "./ObservationReportingForm.vue?vue&type=script&lang=js"
export * from "./ObservationReportingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cafd464",
  null
  
)

export default component.exports